import request from '@/utils/request'
// 考试接口
export function Exercises() {//考试题目
	return request({
		url:`/exam/exercises`,
		method: 'get'
	})
}
export function Examrecord(data) {//考试结果
	return request({
		url:`/exam/record/${data.id}`,
		method: 'get'
	})
}
export function Examtijiao(data) {//提交考试结果
	return request({
		url:`exam`,
		method: 'post',
		data:data
	})
}
export function ExamQuestion(data) {//考试常见问题
	return request({
		url:`/examQuestion/page`,
		method: 'post',
		data:data
	})
}